import { render, staticRenderFns } from "./SalesPageTab.vue?vue&type=template&id=2afede46"
import script from "./SalesPageTab.vue?vue&type=script&lang=js"
export * from "./SalesPageTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports